import React, { useState, useRef, useEffect } from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

const InfoTooltip = ({ content, position = 'top' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const timeoutRef = useRef(null);

  const handleMouseEnter = () => {
    // Show tooltip after 100ms (0.1 seconds)
    timeoutRef.current = setTimeout(() => {
      setIsVisible(true);
    }, 100);
  };

  const handleMouseLeave = () => {
    // Clear timeout if mouse leaves before 100ms
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setIsVisible(false);
  };

  useEffect(() => {
    // Cleanup on unmount
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  // Determine tooltip position classes
  const positionClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2',
    'right bottom': 'left-full top-0 ml-2',
    'right top': 'left-full bottom-0 ml-2',
    'left bottom': 'right-full top-0 mr-2',
    'left top': 'right-full bottom-0 mr-2'
  };

  // Get the arrow direction based on position
  const arrowClasses = {
    top: 'bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2',
    bottom: 'top-0 left-1/2 -translate-x-1/2 -translate-y-1/2',
    left: 'right-0 top-1/2 -translate-y-1/2 translate-x-1/2',
    right: 'left-0 top-1/2 -translate-y-1/2 -translate-x-1/2',
    'right bottom': 'left-0 top-2 -translate-x-1/2',
    'right top': 'left-0 bottom-2 -translate-x-1/2',
    'left bottom': 'right-0 top-2 translate-x-1/2',
    'left top': 'right-0 bottom-2 translate-x-1/2'
  };

  return (
    <div className="relative inline-block">
      <InformationCircleIcon
        className="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-help inline-block ml-1"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      />
      {isVisible && (
        <div
          className={`absolute z-[9999] px-3 py-2 text-xs text-white bg-gray-800 rounded-lg shadow-2xl whitespace-normal w-64 ${positionClasses[position]}`}
          style={{ pointerEvents: 'none' }}
        >
          {content}
          {/* Arrow */}
          <div className={`absolute w-2 h-2 bg-gray-800 transform rotate-45 ${arrowClasses[position]}`} />
        </div>
      )}
    </div>
  );
};

export default InfoTooltip;

